import $ from "jquery";
import Gtm from "./GTM";
import Store from "./Store";
import DataStoreProps from "../types/DataStore";
declare let dataStore: DataStoreProps;

class SubscribeForm {
    constructor() {
        this.SetCurrentStore();
        this.InitSubscribeForm();
    }

    SetCurrentStore() {
        const $subscribeForm = $("#form-subscribe");
        if ($subscribeForm.length === 0) {
            return;
        }
        const currentStore = dataStore.current_store?.length
            ? dataStore.current_store
            : Store.getCurrentStore();
        if (!currentStore) return;

        const storeName =
            typeof currentStore === "string"
                ? currentStore
                : currentStore.title;

        $subscribeForm
            .find("#form-subscribe-select-store option")
            .each(function () {
                const storeOptionName = $(this).html();
                if (
                    compareStringOnlyLettersIgnoreCase(
                        storeOptionName,
                        storeName,
                    )
                ) {
                    $subscribeForm
                        .find("#form-subscribe-select-store")
                        .val($(this).val() || "");
                    $(this).prop("selected", true);
                }
            });
    }

    InitSubscribeForm() {
        const subscribeApiBase = "/api/subscribe/";
        const $subscribeForm = $("#form-subscribe");
        const $subscribeFormWrapper = $subscribeForm.closest(
            ".text-image-block__text-content",
        );
        const gtm = new Gtm();

        if ($subscribeForm.length === 0) {
            return;
        }

        const $errorMessageContainer = $subscribeForm.find(
            "#form-subscribe-error-message",
        );
        const $successMessageContainer = $subscribeForm.find(
            "#form-subscribe-success-message",
        );
        const $submitButton = $subscribeForm.find("input[type=submit]");

        function formError(message: string) {
            $subscribeFormWrapper.addClass("vertical-padding");
            $errorMessageContainer.show();
            $errorMessageContainer.find(".error-message").text(message);
            return false;
        }

        function formSuccess(message: string) {
            $subscribeFormWrapper.addClass("vertical-padding");
            $successMessageContainer.show();
            $successMessageContainer.find(".success-message").text(message);
        }

        $subscribeForm.on("submit", function (ev) {
            ev.preventDefault();
            $errorMessageContainer.hide();
            $successMessageContainer.hide();

            const email = $(this).find("#form-subscribe-email").val() as
                | string
                | string[];
            const mailChimpList = $(this)
                .find("#form-subscribe-select-store")
                .val() as string | string[];
            const selectedStore = $(this)
                .find("#form-subscribe-select-store option:selected")
                .text() as string | string[];
            const isConfirm = $(this)
                .find("#form-subscribe-policy-checkbox")
                .is(":checked");

            if (mailChimpList.length === 0) {
                return formError("Välj butik i listan.");
            }

            if (
                email &&
                (email.length < 5 ||
                    !email.includes("@") ||
                    !email.includes("."))
            ) {
                return formError(
                    "Ange en giltig e-postadress, t.ex. namn@exempel.se",
                );
            }
            if (!email) {
                return formError("Ingen e-postadress ifylld");
            }
            if (!isConfirm) {
                return formError(
                    "Integritetspolicyn måste godkännas för att prenumerera.",
                );
            }

            const subscribeData = {
                Email: email,
                MailChimpList: mailChimpList,
            };

            $.post(subscribeApiBase + "Subscribe/", subscribeData)
                .done(function (data) {
                    try {
                        const jsonData = JSON.parse(data);
                        if (data && jsonData?.title === "Member Exists") {
                            formError(
                                "Din e-postadress är redan registrerad. Kontakta oss gärna om du har frågor eller vill uppdatera dina inställningar",
                            );
                            return;
                        }
                        if (!data || !jsonData.id) {
                            formError(
                                "Kunde inte anmäla. Testa gärna igen lite senare. ",
                            );
                        } else {
                            formSuccess("Tack! Håll utkik i din inkorg!");
                            $submitButton.attr("disabled", "disabled");
                            gtm.datalayerPush("newsletter_signup", {
                                selected_store: selectedStore,
                                selected_list: mailChimpList,
                            });
                        }
                    } catch {
                        formError(
                            "Kunde inte anmäla. Är du redan prenumerant?",
                        );
                    }
                })
                .fail(function () {
                    formError("Okänt fel, testa gärna igen lite senare");
                });
        });
    }
}

const compareStringOnlyLettersIgnoreCase = (str1: string, str2: string) => {
    return (
        str1.replace(/[^a-zåäöA-ZÅÄÖ]/g, "").toLowerCase() ===
        str2.replace(/[^a-zåäöA-ZÅÄÖ]/g, "").toLowerCase()
    );
};

export default SubscribeForm;
